module.exports = __webpack_public_path__ + "static/media/Arial_Rounded_MT_ExtraBold.5a74e6de.svg";